import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
// import { ReloadOutlined, ExclamationCircleOutlined, CloseCircleOutlined, QuestionCircleOutlined, SettingOutlined, UploadOutlined, DownOutlined } from '@ant-design/icons';
import { App, Button, Col, Flex, Form, Input, Row, Space, Table, Dropdown, Typography, Modal, message, Tooltip, Divider, Popover, Switch, Drawer, Upload, Radio, Select, Image as AntdImage, Alert } from 'antd';
import { useHorizontalScrollGuard } from '@/hooks/useHorizontalScrollGuard';
import { useFilterPanelVisible } from '@/hooks/useFilterPanelVisible';
import { useTableScrollY } from '@/hooks/useTableScrollY';
import { useVerticalScrollShadow } from '@/hooks/useVerticalScrollShadow';
import { useEnableTableScrollYLayout } from '@/layouts/tableScrollLayout';
import InvitationUsersFilterPanel from './InvitationUsersFilterPanel';
import { getInvitationUserListApi, deleteInvitationUserApi, exportInvitationLink, sendMpMessageApi, updateInvitationRemarksApi } from '@services/Invitation/InvitationUser';
import { getInvitationOneApi, invitationUsersStatusApi, setPdfInvitationApi, exportInvitationPdfFile, setUserPdfInvitationApi } from '@services/Invitation/Invitation';
import dayjs from 'dayjs';
import copy from 'copy-to-clipboard';
import QRCode from 'qrcode.react';
import config from '@config';
import './InvitationUsers.less';
import { invitationNameTitles } from '../../utils/constants';
import { invitationActions } from './store/invitationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { TABLE_PAGE_SIZE_OPTIONS, drawerWidth } from '../../utils/property';
import AddGuest from './components/AddGuest';
import GuestInfo from './components/GuestInfo';
import ConfirmInvite from './components/ConfirmInvite';
import TinyMCEEditor from '../Conference/components/Editor/TinyMCEEditor';
import WorkExperiences from '@/components/common/WorkExperiences';
import ExpertInfoCard from '@/components/common/ExpertInfoCard';
import GuestTaskList from '@/components/common/GuestTaskList';
import GuestRemarksCell, { GuestRemarksEditModal } from '@/components/common/GuestRemarksCell';
import { getGuestRemarksFromRecord } from '@/components/common/guestRemarks';
import InvitationScriptModal from './InvitationScriptModal';
import { prepareBCOSSUrl } from '../../utils/utils';
import { cloneDeep, isEmpty } from 'lodash';
import { fileApi, setupInvitationFile } from '../../services/Invitation/Invitation';
import { exportInvitationFile, setupUserInvitationFile } from '../../services/Invitation/InvitationUser';
import { getInvitationGroupOneApi } from '../../services/Invitation/InvitationGroup';
import { conferenceOnceApi } from '../../services/Conference';
import PageHeader from '@components/PageHeader/PageHeader';
const { Text } = Typography;

const { setUserFilter: setFilter, setUserCursor: setCursor } = invitationActions;

/** Word 邀请函红头主体名称 */
const WORD_INVITATION_RED_HEAD_TITLES = ['北京华媒康讯信息技术股份有限公司', '北京健康界科技有限责任公司', '海南博鳌医学创新研究院', '北京尚医联合文化传播有限公司'];

export default function InvitationUsers() {
    const { message: appMessage } = App.useApp();
    const navigate = useNavigate();
    const params = useParams();
    const gid = params?.gid || 0;
    const id = params?.id || 0;
    console.log('gid', gid, 'id', id);

    const dispatch = useDispatch();
    const filter = useSelector(state => state.invitation.user.filter);
    const cursor = useSelector(state => state.invitation.user.cursor);
    const { filterToggleProps, FilterPanelSlot } = useFilterPanelVisible();
    // console.log(filter, cursor);

    // 表格自适应高度 / 全屏
    const tableRegionRef = useRef(null);
    const tableScrollContainerRef = useRef(null);
    const [scrollContainerVersion, setScrollContainerVersion] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const enableTableScrollYLayout = useEnableTableScrollYLayout();
    const tableDeductSelectors = useMemo(() => ['.main-toolbar'], []);
    const tableScrollY = useTableScrollY(tableRegionRef, {
        enabled: enableTableScrollYLayout || isFullscreen,
        heightRootClassName: 'main-container-card',
        scrollYOffset: 0,
        deductSiblingSelectors: tableDeductSelectors,
    });

    useHorizontalScrollGuard(tableScrollContainerRef, {
        threshold: 6,
        edgeHoldMs: 220,
        watchValue: scrollContainerVersion,
    });
    useVerticalScrollShadow(tableScrollContainerRef, {
        threshold: 2,
        watchValue: scrollContainerVersion,
    });

    useLayoutEffect(() => {
        const region = tableRegionRef.current;
        if (!region) return;

        const resolveScrollContainer = () => {
            const next = region.querySelector('.ant-table-body') ?? region.querySelector('.ant-table-content');
            if (tableScrollContainerRef.current !== next) {
                tableScrollContainerRef.current = next;
                setScrollContainerVersion(v => v + 1);
            }
        };

        resolveScrollContainer();

        let rafId = 0;
        const mutationObserver = new MutationObserver(() => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                rafId = 0;
                resolveScrollContainer();
            });
        });
        mutationObserver.observe(region, { childList: true, subtree: true });

        return () => {
            if (rafId) cancelAnimationFrame(rafId);
            mutationObserver.disconnect();
        };
    }, []);

    const handleToggleFullscreen = useCallback(() => {
        const target = document.querySelector('main.main-container');
        if (!target) return;
        const next = !target.classList.contains('is-page-fullscreen');
        target.classList.toggle('is-page-fullscreen', next);
        setIsFullscreen(next);
    }, []);

    useEffect(() => {
        const onKeyDown = e => {
            if (e.key !== 'Escape') return;
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (!target) return;
            target.classList.remove('is-page-fullscreen');
            setIsFullscreen(false);
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);

    useEffect(() => {
        return () => {
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (target) target.classList.remove('is-page-fullscreen');
        };
    }, []);

    const [visibleAddUserDrawer, setVisibleAddUserDrawer] = useState(false);
    const [guestInfoDrawer, setGuestInfoDrawer] = useState(false);
    const [currentExpertId, setCurrentExpertId] = useState();
    const [currentUserCode, setCurrentUserCode] = useState();

    const [total, setTotal] = useState(0);
    const [data, setData] = useState([]);
    const [invitationOne, setInvitationOne] = useState({});
    const [invitationGroupOne, setInvitationGroupOne] = useState('');
    const [confirmInviteOpen, setConfirmInviteOpen] = useState(false);

    const [visibleSetupInvitation, setVisibleSetupInvitation] = useState(false);

    const [setupInvitationForm] = Form.useForm();

    const [invitationFileCoverUrlList, setInvitationFileCoverUrlList] = useState([]);
    const [invitationBodyBgUrlList, setInvitationBodyBgUrlList] = useState([]);

    const [setupInvitationUser, setSetupInvitationUser] = useState(null); // 定制某个邀请用户的电子邀请函

    const [downloadCountDown, setDownloadCountDown] = useState(0);

    // pdf 官方邀请函
    const [setupPdfInvitationForm] = Form.useForm();
    const watchEnabled = Form.useWatch('enabled', setupPdfInvitationForm);
    const [visibleSetupPdfInvitation, setVisibleSetupPdfInvitation] = useState(false);
    const [pdfInvitationFileCoverUrlList, setPdfInvitationFileCoverUrlList] = useState([]);
    const [pdfInvitationBodyBgUrlList, setPdfInvitationBodyBgUrlList] = useState([]);
    const [downloadPdfCountDown, setDownloadPdfCountDown] = useState(0);

    // 邀请话术 Modal
    const [invitationScriptModalVisible, setInvitationScriptModalVisible] = useState(false);
    const [currentGuestForScript, setCurrentGuestForScript] = useState(null);

    // PDF下载Modal相关状态
    const [pdfDownloadModalOpen, setPdfDownloadModalOpen] = useState(false);
    const [currentPdfRecord, setCurrentPdfRecord] = useState(null);

    const [remarksModalOpen, setRemarksModalOpen] = useState(false);
    const [remarksSaving, setRemarksSaving] = useState(false);
    const [remarksEditing, setRemarksEditing] = useState(null);
    const [remarksForm] = Form.useForm();

    useEffect(() => {
        if (!remarksModalOpen) return;
        remarksForm.setFieldsValue({
            remarks: getGuestRemarksFromRecord(remarksEditing),
        });
    }, [remarksModalOpen, remarksEditing, remarksForm]);

    const isAllowCheck = useRef(null);
    /** Form.List 在 render 内调用 add() 会触发 React 警告；用 microtask 推迟，并用 ref 避免 Strict Mode 双次 render 重复 add */
    const setupWordContactsEnsureRef = useRef(false);
    const setupPdfContactsEnsureRef = useRef(false);

    const optionHeaders = { headers: { 'Content-Type': 'multipart/form-data' } };

    const [conference, setConference] = useState(null);

    // 通过邀请函的 gid 查询会议 ID，进而查询到会议详情
    // 会议进入劳务阶段，禁用代嘉宾确认任务 !!conference?.laborFeeConfirmedAt
    const getInvitationGroupConferenceInfo = async gid => {
        const res = await getInvitationGroupOneApi({ id: gid });
        if (res.status_code === 200) {
            // console.log(res.data);
            const invitationGroup = res.data;
            if (!isEmpty(invitationGroup)) {
                setInvitationGroupOne(invitationGroup.name);
            }
            if (!isEmpty(invitationGroup) && invitationGroup.applicationType === 1) {
                const confRes = await conferenceOnceApi({ id: invitationGroup.applicationItemId });
                if (confRes.status_code === 200) {
                    // console.log(confRes.data);
                    const conf = confRes.data;
                    if (!isEmpty(conf)) {
                        // console.log(conf);
                        setConference(conf);
                    }
                }
            }
        }
    };

    useEffect(() => {
        if (gid) {
            getInvitationGroupConferenceInfo(gid);
        }
    }, []);

    useEffect(() => {
        let timer;
        if (downloadCountDown > 0) {
            timer = setTimeout(() => {
                setDownloadCountDown(downloadCountDown - 1);
            }, 1000);
        }

        return () => clearTimeout(timer);
    }, [downloadCountDown]);

    useEffect(() => {
        let timer;
        if (downloadPdfCountDown > 0) {
            timer = setTimeout(() => {
                setDownloadPdfCountDown(downloadPdfCountDown - 1);
            }, 1000);
        }

        return () => clearTimeout(timer);
    }, [downloadPdfCountDown]);

    // 打开pdf官方邀请函设置表单
    const openSetupPdfInvitation = (invitationUser = null) => {
        if (isEmpty(invitationUser)) {
            // 统一
            setSetupInvitationUser(null);

            if (!isEmpty(invitationOne?.invitationPdfSettings)) {
                const invitationPdfSettings = invitationOne.invitationPdfSettings;
                setupPdfInvitationForm.setFieldsValue({ ...invitationPdfSettings });
            }
        } else {
            // 定制
            console.log(invitationUser);
            const user = cloneDeep(invitationUser);
            let invitationPdfSettings = null;
            if (user?.invitationUsers?.invitationPdfSettings) {
                invitationPdfSettings = JSON.parse(user.invitationUsers.invitationPdfSettings) || null;
            }

            if (user?.invitationUsers && !isEmpty(invitationPdfSettings)) {
                user.invitationUsers.invitationPdfSettings = invitationPdfSettings;
            }

            setSetupInvitationUser(user);

            let settings = { enabled: true }; // 默认开启pdf邀请函
            if (!isEmpty(invitationOne?.invitationPdfSettings)) {
                settings = { ...settings, ...invitationOne.invitationPdfSettings };
            }
            if (!isEmpty(invitationPdfSettings)) {
                settings = {
                    ...settings, // 统一设置
                    ...invitationPdfSettings, // 定制设置
                    enabled: invitationPdfSettings.enabled !== false,
                };
                console.log(settings);
            }
            setupPdfInvitationForm.setFieldsValue(settings);
        }
        setVisibleSetupPdfInvitation(true);
    };

    // 打开电子邀请函设置表单
    const openSetupInvitation = (invitationUser = null) => {
        setupInvitationForm.resetFields();

        if (isEmpty(invitationUser)) {
            // 统一邀请函设置表单

            setSetupInvitationUser(null);

            if (!isEmpty(invitationOne?.invitationFileSettings)) {
                const invitationFileSettings = invitationOne.invitationFileSettings;
                const settings = {
                    ...invitationFileSettings,
                    // 统一设置中的字段处理
                    titleEnabled: !!invitationFileSettings?.titleEnabled,
                    letterEnabled: !!invitationFileSettings?.letterEnabled,
                    confDetailsEnabled: !!invitationFileSettings?.confDetailsEnabled,
                    taskEnabled: !!invitationFileSettings?.taskEnabled,
                    relatedConfHallsOnly: !!invitationFileSettings?.relatedConfHallsOnly,
                    redHeadEnabled: !!invitationFileSettings?.redHeadEnabled,
                    redHeadTitle: invitationFileSettings?.redHeadTitle ?? null,
                };
                console.log(settings);
                setupInvitationForm.setFieldsValue(settings);
            }
        } else {
            // 定制邀请函设置表单

            console.log(invitationUser);
            // 浅拷贝，有问题
            // const user = {...invitationUser};
            const user = cloneDeep(invitationUser);
            let invitationFileSettings = null;
            if (user?.invitationUsers?.invitationFileSettings) {
                invitationFileSettings = JSON.parse(user.invitationUsers.invitationFileSettings) || null;
            }
            // console.log(invitationFileSettings);
            if (user?.invitationUsers && !isEmpty(invitationFileSettings)) {
                user.invitationUsers.invitationFileSettings = invitationFileSettings;
            }
            // console.log(invitationUser);
            setSetupInvitationUser(user);

            let settings = {};
            if (!isEmpty(invitationOne?.invitationFileSettings)) {
                settings = { ...invitationOne.invitationFileSettings };
            }
            if (!isEmpty(invitationFileSettings)) {
                settings = {
                    ...settings, // 统一设置
                    ...invitationFileSettings, // 定制设置
                };
            }
            if (!isEmpty(settings)) {
                settings = {
                    ...settings,
                    titleEnabled: !!settings.titleEnabled,
                    letterEnabled: !!settings.letterEnabled,
                    confDetailsEnabled: !!settings.confDetailsEnabled,
                    taskEnabled: !!settings.taskEnabled,
                    relatedConfHallsOnly: !!settings.relatedConfHallsOnly,
                    redHeadEnabled: !!settings.redHeadEnabled,
                    redHeadTitle: settings.redHeadTitle ?? null,
                };
                console.log(settings);
            }
            setupInvitationForm.setFieldsValue(settings);
        }

        setVisibleSetupInvitation(true);
    };

    const closeSetupInvitation = () => {
        setSetupInvitationUser(null);
        setVisibleSetupInvitation(false);
        setupWordContactsEnsureRef.current = false;
    };

    const setupInvitation = () => {
        setupInvitationForm
            .validateFields()
            .then(async values => {
                // console.log(values);
                // return;

                let invitationFileSettings = {
                    ...values,
                    titleEnabled: !!values.titleEnabled ? 1 : 0,
                    letterEnabled: !!values.letterEnabled ? 1 : 0,
                    confDetailsEnabled: !!values.confDetailsEnabled ? 1 : 0,
                    taskEnabled: !!values.taskEnabled ? 1 : 0,
                    relatedConfHallsOnly: !!values.relatedConfHallsOnly ? 1 : 0,
                };

                // 开启大会详情，处理标题和内容
                if (values.confDetailsEnabled) {
                    invitationFileSettings = {
                        ...invitationFileSettings,
                        confDetailsTitle: values.confDetailsTitle,
                        confDetails: values.confDetails,
                    };
                }

                // 开启嘉宾任务，处理任务形式和联系人
                if (values.taskEnabled) {
                    invitationFileSettings = {
                        ...invitationFileSettings,
                        taskForm: values.taskForm,
                        contactFrom: values.contactFrom,
                    };

                    if (values.contactFrom === 2) {
                        // 联系人来源是自定义时
                        invitationFileSettings = {
                            ...invitationFileSettings,
                            contacts: values.contacts,
                        };
                    }
                }

                // 邀请辞页：红头
                if (values.letterEnabled) {
                    invitationFileSettings.redHeadEnabled = values.redHeadEnabled ? 1 : 0;
                    invitationFileSettings.redHeadTitle = values.redHeadEnabled ? values.redHeadTitle : null;
                } else {
                    invitationFileSettings.redHeadEnabled = 0;
                    invitationFileSettings.redHeadTitle = null;
                }
                delete invitationFileSettings.customTitle;

                if (values.coverUrl) {
                    invitationFileSettings.coverUrl = values.coverUrl;
                }
                if (values.bodyBgUrl) {
                    invitationFileSettings.bodyBgUrl = values.bodyBgUrl;
                }

                console.log(invitationFileSettings);
                // return;

                if (!isEmpty(setupInvitationUser)) {
                    // 定制电子邀请函设置

                    const data = {
                        id: setupInvitationUser.invitationUsers.id, // 邀请用户（关联表的记录）ID
                        invitationFileSettings: JSON.stringify(invitationFileSettings),
                    };
                    const res = await setupUserInvitationFile(data);
                    if (res.status_code === 200) {
                        message.success('定制电子邀请函成功');

                        setSetupInvitationUser(null);
                        setupInvitationForm.resetFields();
                        setVisibleSetupInvitation(false);

                        getInvitationUsers();
                    }
                } else {
                    // （统一）电子邀请函设置

                    const data = {
                        id, // invitation id
                        invitationFileSettings: JSON.stringify(invitationFileSettings),
                    };
                    const res = await setupInvitationFile(data);
                    if (res.status_code === 200) {
                        message.success('电子邀请函设置成功');

                        setupInvitationForm.resetFields();
                        setVisibleSetupInvitation(false);

                        getInvitationInfo(id);
                    }
                }
            })
            .catch(error => message.warning('请完善电子邀请函设置中的必填项再提交'));
    };

    // pdf邀请函关闭drawer
    const closeSetupPdfInvitation = () => {
        setVisibleSetupPdfInvitation(false);
        setupPdfContactsEnsureRef.current = false;
    };

    // pdf邀请函表单提交
    const setupPdfInvitation = () => {
        setupPdfInvitationForm
            .validateFields()
            .then(async values => {
                const invitationPdfSettings = {
                    ...values,
                    last_updated_at: dayjs().format('YYYY-MM-DD HH:mm:ss'), // 当前时间格式化为 YYYY-MM-DD HH:mm:ss
                };

                if (!isEmpty(setupInvitationUser)) {
                    // 定制电子邀请函设置
                    const res = await setUserPdfInvitationApi({ id: setupInvitationUser.invitationUsers.id, expertId: setupInvitationUser.invitationUsers.expertId, invitationPdfSettings: JSON.stringify(invitationPdfSettings) });
                    if (res.status_code === 200) {
                        message.success('定制PDF官方邀请函模板设置成功');
                        setSetupInvitationUser(null);
                        setupPdfInvitationForm.resetFields();
                        setVisibleSetupPdfInvitation(false);

                        getInvitationUsers();
                    }
                } else {
                    // （统一）电子邀请函设置
                    const res = await setPdfInvitationApi({ id, invitationPdfSettings: JSON.stringify(invitationPdfSettings) });
                    if (res.status_code === 200) {
                        message.success('PDF官方邀请函模板设置成功');
                        setupPdfInvitationForm.resetFields();
                        setVisibleSetupPdfInvitation(false);

                        getInvitationInfo(id);
                    }
                }
            })
            .catch(error => message.warning('请完善PDf官方邀请函设置中的必填项再提交'));
    };

    const checkout = (file, size) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        // 判断类型
        if (!isJpgOrPng) {
            message.error('仅支持上传JPG/PNG格式的图片');
            isAllowCheck.current = true;
            return false;
        } else {
            isAllowCheck.current = false;
        }

        // 判断大小
        const isLt5M = file.size / 1024 / 1024 < size;
        if (!isLt5M) {
            message.error(`图片不能大于${size}MB`);
            isAllowCheck.current = true;
            return false;
        } else {
            isAllowCheck.current = false;
        }

        return isJpgOrPng && isLt5M;
    };

    // 封面上传
    const uploadInvitationCover = (info, type) => {
        const formData = new FormData();
        formData.append('file', info.file);
        formData.append('type', 14);

        fileApi(formData, optionHeaders).then(res => {
            if (!res) {
                message.error('文件上传失败');
                return false;
            }
            if (res.status_code === 200) {
                if (type === 1) {
                    setInvitationFileCoverUrlList([prepareBCOSSUrl(res.data)]);
                    setupInvitationForm.setFieldValue('coverUrl', res.data);
                }
                if (type === 2) {
                    setPdfInvitationFileCoverUrlList([prepareBCOSSUrl(res.data)]);
                    setupPdfInvitationForm.setFieldValue('coverUrl', res.data);
                }
            }
        });
    };

    // 背景图上传
    const uploadInvitationBodyBg = (info, type) => {
        const formData = new FormData();
        formData.append('file', info.file);
        formData.append('type', 14);

        fileApi(formData, optionHeaders).then(res => {
            if (!res) {
                message.error('文件上传失败');
                return false;
            }
            if (res.status_code === 200) {
                if (type === 1) {
                    setInvitationBodyBgUrlList([prepareBCOSSUrl(res.data)]);
                    setupInvitationForm.setFieldValue('bodyBgUrl', res.data);
                }
                if (type === 2) {
                    setPdfInvitationBodyBgUrlList([prepareBCOSSUrl(res.data)]);
                    setupPdfInvitationForm.setFieldValue('bodyBgUrl', res.data);
                }
            }
        });
    };

    // 下载word邀请函
    const downloadInvitationFile = async invitationUser => {
        if (!isEmpty(invitationUser)) {
            if (downloadCountDown === 0) {
                setDownloadCountDown(10);

                message.success('请稍后，正在生成文件');

                let nameWithTitle = invitationUser?.memUsername || '';
                const nameTitle = invitationOne?.nameTitle || 1;
                const expertInfo = invitationUser?.ssoMemberWorkExperiencesEntities?.[0] || {};
                const expertPost = expertInfo?.unitPost || '';

                // 用户称呼1=无,2=先生/女士,3=教授,4=嘉宾,5=老师,6=专家职务
                if (nameTitle === 6) {
                    nameWithTitle += expertPost;
                } else {
                    nameWithTitle += invitationNameTitles?.find(t => t.type === nameTitle)?.title || '';
                }
                console.log(nameTitle, expertInfo, expertPost);

                const params = {
                    invitationId: id,
                    expertId: invitationUser.id,
                };
                const res = await exportInvitationFile(params);

                const blob = new Blob([res], { type: 'application/octet-stream' });

                if ('download' in document.createElement('a')) {
                    const link = document.createElement('a');
                    link.style.display = 'none';
                    link.download = `${nameWithTitle}_邀请函_${conference.name}.docx`;
                    link.href = URL.createObjectURL(blob);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    link.remove();
                } else {
                    navigator.msSaveBlob(blob);
                }
            }
        } else {
            // TODO
        }
    };

    // 打开PDF下载Modal
    const downloadInvitationPdfFile = invitationUser => {
        if (!isEmpty(invitationUser)) {
            setCurrentPdfRecord(invitationUser);
            setPdfDownloadModalOpen(true);
        }
    };

    // 立即下载已存在的PDF
    const downloadExistingPdf = async invitationUser => {
        if (!isEmpty(invitationUser) && invitationUser?.invitationUsers?.pdfUrl) {
            try {
                // 构建文件名
                const nameTitle = invitationOne?.nameTitle || 1;
                const expertInfo = invitationUser?.ssoMemberWorkExperiencesEntities?.[0] || {};
                const expertPost = expertInfo?.unitPost || '';

                let titleSuffix = '';
                // 用户称呼1=无,2=先生/女士,3=教授,4=嘉宾,5=老师,6=专家职务
                if (nameTitle === 6) {
                    titleSuffix = expertPost;
                } else {
                    titleSuffix = invitationNameTitles?.find(t => t.type === nameTitle)?.title || '';
                }

                const fileName = `邀请函_诚邀${invitationUser?.memUsername}${titleSuffix}出席${invitationOne?.name || '会议'}.pdf`;

                // 使用blob下载，添加时间戳消除CDN缓存
                const pdfUrl = prepareBCOSSUrl(invitationUser.invitationUsers.pdfUrl) + `?t=${Date.now()}`;
                const response = await fetch(pdfUrl);
                const blob = await response.blob();

                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);

                setPdfDownloadModalOpen(false);
            } catch (error) {
                message.error('下载失败，请稍后重试');
            }
        }
    };

    // 重新生成PDF邀请函
    const regeneratePdfInvitation = async invitationUser => {
        if (!isEmpty(invitationUser)) {
            if (downloadPdfCountDown === 0) {
                setDownloadPdfCountDown(10);

                message.success('请稍后，正在生成文件');

                const nameTitle = invitationOne?.nameTitle || 1;
                const expertInfo = invitationUser?.ssoMemberWorkExperiencesEntities?.[0] || {};
                const expertPost = expertInfo?.unitPost || '';

                const params = {
                    invitationId: id,
                    expertId: invitationUser.id,
                    redo: 1, // 强制重新生成
                };
                const res = await exportInvitationPdfFile(params);
                if (res.status_code === 200 && res.data) {
                    try {
                        // 构建文件名
                        let titleSuffix = '';
                        // 用户称呼1=无,2=先生/女士,3=教授,4=嘉宾,5=老师,6=专家职务
                        if (nameTitle === 6) {
                            titleSuffix = expertPost;
                        } else {
                            titleSuffix = invitationNameTitles?.find(t => t.type === nameTitle)?.title || '';
                        }

                        const fileName = `邀请函_诚邀${invitationUser?.memUsername}${titleSuffix}出席${invitationOne?.name || '会议'}.pdf`;

                        // 使用blob下载，添加时间戳消除CDN缓存
                        const pdfUrl = prepareBCOSSUrl(res.data) + `?t=${Date.now()}`;
                        const response = await fetch(pdfUrl);
                        const blob = await response.blob();

                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                        document.body.removeChild(link);

                        message.success('PDF邀请函生成并下载成功');
                    } catch (error) {
                        message.error('下载失败，请稍后重试');
                        console.error('PDF下载失败:', error);
                    }

                    // 刷新数据以获取最新的PDF信息
                    getInvitationUsers();
                }
                setPdfDownloadModalOpen(false);
            }
        }
    };

    // 分页
    const onChangePage = (page, pageSize) => {
        setData([]);
        dispatch(
            setFilter({
                ...filter,
                page,
                pageSize,
            }),
        );
    };
    const onShowSizeChange = (current, size) => onChangePage(1, size);

    const onFinish = values => {
        const newFilter = {
            ...filter,
            ...values,
            page: 1,
        };
        // 兼容接口未处理 [] 的情况
        if (isEmpty(newFilter?.expertLevels)) {
            delete newFilter.expertLevels;
        }
        if (newFilter.hasRemarks !== 0 && newFilter.hasRemarks !== 1) {
            delete newFilter.hasRemarks;
        }
        const remarksKeyword = typeof newFilter.remarksKeyword === 'string' ? newFilter.remarksKeyword.trim() : '';
        if (newFilter.hasRemarks === 0 || !remarksKeyword) {
            delete newFilter.remarksKeyword;
        } else {
            newFilter.remarksKeyword = remarksKeyword;
        }
        dispatch(setFilter(newFilter));
    };

    const onReset = () => {
        dispatch(
            setFilter({
                page: 1,
                pageSize: filter.pageSize,
            }),
        );
    };

    const handleRefresh = () => getInvitationUsers();

    const getInvitationUsers = async () => {
        try {
            const params = {
                ...filter,
                limit: filter.pageSize,
                invitationGroupId: gid,
                invitationId: id,
            };

            const res = await getInvitationUserListApi(params);
            if (res.status_code === 200) {
                setData(res.data?.list);
                setTotal(res.data?.totalCount);
            }
        } catch (e) {
            //
        }
    };

    const getInvitationInfo = async id => {
        const res = await getInvitationOneApi({ id });
        if (res.status_code === 200) {
            const invitation = res.data;

            // word邀请函回显
            if (!!invitation?.invitationFileSettings) {
                invitation['invitationFileSettings'] = JSON.parse(invitation.invitationFileSettings) || null;
                if (!!invitation.invitationFileSettings?.coverUrl) {
                    setInvitationFileCoverUrlList([prepareBCOSSUrl(invitation.invitationFileSettings.coverUrl)]);
                }
                if (!!invitation.invitationFileSettings?.bodyBgUrl) {
                    setInvitationBodyBgUrlList([prepareBCOSSUrl(invitation.invitationFileSettings.bodyBgUrl)]);
                }
            }

            // pdf邀请函回显
            if (!!invitation?.invitationPdfSettings) {
                invitation['invitationPdfSettings'] = JSON.parse(invitation.invitationPdfSettings) || null;
                if (!!invitation.invitationPdfSettings?.coverUrl) {
                    setPdfInvitationFileCoverUrlList([prepareBCOSSUrl(invitation.invitationPdfSettings.coverUrl)]);
                }
                if (!!invitation.invitationPdfSettings?.bodyBgUrl) {
                    setPdfInvitationBodyBgUrlList([prepareBCOSSUrl(invitation.invitationPdfSettings.bodyBgUrl)]);
                }
            }

            setInvitationOne(invitation);
        }
    };

    useEffect(() => {
        getInvitationUsers();
    }, [filter]);

    useEffect(() => {
        if (!!id) {
            getInvitationInfo(id);
        }
    }, []);

    const onResetGuest = () => {
        getInvitationUsers();
    };

    // 删除
    const onDeleteInvitationUser = expertId => {
        Modal.confirm({
            title: '提示',
            content: '确定删除当前邀请函用户？',
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                deleteInvitationUserApi({ expertId: expertId, invitationId: invitationOne.id }).then(res => {
                    if (res.status_code === 200) {
                        message.success(res.message);
                    }

                    navigate(`/invitation/g/${gid}/invitations/${id}/users`);
                    getInvitationUsers();
                });
            },
        });
    };

    const onConfirmInvitation = record => {
        setCurrentUserCode(record.invitationUsers.userCode);
        setConfirmInviteOpen(true);
    };

    const openAddUserDrawer = () => {
        setVisibleAddUserDrawer(true);
    };

    const closeAddUserDrawer = () => {
        setVisibleAddUserDrawer(false);
    };

    const openViewGuestInfoDrawer = id => {
        dispatch(setCursor(id));
        setCurrentExpertId(id);
        setGuestInfoDrawer(true);
    };

    const closeGuestInfoDrawer = () => {
        setGuestInfoDrawer(false);
    };

    const copyInvitationLink = item => {
        let invitationLink = `${config.INVITATION_PREFIX}`;
        invitationLink += `/${item?.invitationUsers?.userCode}`;

        copy(invitationLink);
        message.success('复制成功');

        dispatch(setCursor(item.id));
    };

    const copyInvitationText = item => {
        // 打开邀请话术 Modal
        setCurrentGuestForScript(item);
        setInvitationScriptModalVisible(true);
        dispatch(setCursor(item.id));
    };

    const getInvitationUrl = invitation => `${config.INVITATION_PREFIX}/${invitation?.invitationUsers?.userCode}`;

    const downloadQRCode = invitation => {
        const userCode = invitation?.invitationUsers?.userCode;
        if (!!userCode) {
            const qrCode = document.getElementById(userCode);
            const image = new Image();
            image.src = qrCode.toDataURL('image/png');
            const link = document.getElementById(`link_${userCode}`);
            link.href = image.src;
        }
    };

    const toggleAgendaTasks = guestAgendaInfo => {
        setData(
            data.map(item => {
                if (item.id === guestAgendaInfo.id) {
                    return { ...item, expanded: !item.expanded };
                } else {
                    return item;
                }
            }),
        );
    };

    // 发送邀请函通知
    const sendMessage = async item => {
        console.log('send:', item);
        try {
            const params = {
                id: item.invitationUsers?.id,
                conferenceId: item.guestsEntity?.conferenceId,
                conferenceName: item.guestsEntity?.conferenceName,
            };
            const res = await sendMpMessageApi(params);
            if (res.status_code === 200) {
                navigate(`/invitation/g/${gid}/invitations/${id}/users`);
                getInvitationUsers();
            }
        } catch (e) {
            //
        }
    };

    const openRemarksEditor = record => {
        setRemarksEditing(record);
        remarksForm.setFieldsValue({
            remarks: getGuestRemarksFromRecord(record),
        });
        setRemarksModalOpen(true);
    };

    const closeRemarksEditor = () => {
        setRemarksModalOpen(false);
        setRemarksEditing(null);
    };

    const handleSaveRemarks = async () => {
        const conferenceId = remarksEditing?.guestsEntity?.conferenceId;
        const expertId = remarksEditing?.id;
        if (!conferenceId || !expertId) {
            appMessage.error('会议嘉宾不存在');
            return;
        }
        try {
            const values = await remarksForm.validateFields();
            const remarks = (values.remarks ?? '').trim();
            setRemarksSaving(true);
            const res = await updateInvitationRemarksApi({ conferenceId, expertId, remarks });
            if (res?.status_code === 200) {
                appMessage.success('嘉宾备注已保存');
                closeRemarksEditor();
                getInvitationUsers();
            } else {
                appMessage.error(res?.message || '保存嘉宾备注失败');
            }
        } catch (e) {
            if (e?.errorFields) {
                return;
            }
            console.error('保存嘉宾备注失败', e);
            appMessage.error('保存嘉宾备注失败');
        } finally {
            setRemarksSaving(false);
        }
    };

    const columns = [
        {
            title: '基本信息',
            dataIndex: 'memUsername',
            width: 200,
            render: (_, record) => <ExpertInfoCard expert={record} />,
        },

        {
            title: '单位任职',
            dataIndex: 'ssoMemberWorkExperiencesEntities',
            width: 200,
            render: (_, record) => <WorkExperiences workExperiences={record.ssoMemberWorkExperiencesEntities} />,
        },

        {
            title: '邀请函接受状态',
            dataIndex: 'invitationAcceptStatus',
            width: 120,
            render: (_, record) => {
                const invitationAcceptStatus = record?.invitationUsers?.invitationAcceptStatus || 0;
                return (
                    <>
                        {invitationAcceptStatus === 0 && <span>待确认</span>}
                        {invitationAcceptStatus === 1 && <Text type="success">已确认</Text>}
                        {invitationAcceptStatus === 2 && (
                            <>
                                <Text type="danger" style={{ verticalAlign: 'middle' }}>
                                    已拒绝
                                </Text>
                                {!!record?.invitationUsers?.refusalInfo && (
                                    <Tooltip placement="bottom" trigger="click" title={record?.invitationUsers?.refusalInfo}>
                                        <i className="bi bi-chat-dots" style={{ marginLeft: 4, color: '#888', verticalAlign: 'middle' }} />
                                    </Tooltip>
                                )}
                            </>
                        )}
                        {/*{invitationAcceptStatus === 3 && <Text type="warning">待确认</Text>}*/}
                    </>
                );
            },
        },

        {
            title: '嘉宾备注',
            dataIndex: 'remarks',
            width: 220,
            render: (_, record) => <GuestRemarksCell remarks={getGuestRemarksFromRecord(record)} onEdit={() => openRemarksEditor(record)} />,
        },

        {
            title: '项目任务及接受状态',
            dataIndex: 'tasks',
            width: 400,
            render: (_, record) => <GuestTaskList agendasGuestsList={record.agendasGuestsList} expanded={record.expanded} onToggleExpansion={toggleAgendaTasks} record={record} />,
        },

        {
            title: '邀请方',
            dataIndex: 'invitationOrgList',
            width: 200,
            render: (_, record) => {
                const organisations = record?.guestsEntity?.organisations;
                const exclusiveId = record?.guestsEntity?.exclusiveInvitationOrgId;

                return organisations && !!organisations.length ? (
                    <span>
                        {organisations.map((item, index) => (
                            <span key={item.id || index}>
                                {item.name}
                                {exclusiveId && item.id === exclusiveId ? <span style={{ color: '#faad14' }}>(独家)</span> : null}
                                {index < organisations.length - 1 ? '、' : ''}
                            </span>
                        ))}
                    </span>
                ) : (
                    <Text type="secondary">&ndash;</Text>
                );
            },
        },

        {
            title: '权益形式',
            dataIndex: 'rightForm',
            width: 120,
            render: (_, record) => {
                const text = record?.rightForm ? JSON?.parse(record?.rightFormSetting)?.filter(item => item.id === record?.rightForm)[0]?.name : <span>待确认</span>;
                return <>{text}</>;
            },
            hidden: !invitationOne.rightFormEnabled,
        },

        {
            title: '意向选项',
            dataIndex: 'cocreationForm',
            width: 120,
            render: (_, record) => {
                const checkForm = record?.cocreationForm ? JSON?.parse(record?.cocreationForm) : [];
                const FormSet = record?.cocreationFormSetting ? JSON?.parse(record?.cocreationFormSetting) : [];
                const filterForm = FormSet?.filter(item => checkForm?.includes(item.id));
                const text = record?.cocreationForm ? (
                    <>
                        {filterForm && !!filterForm.length && filterForm.map(item => <div key={item.id}>{item.name}</div>)}
                        {checkForm?.includes(-1) && <div>暂不参与</div>}
                    </>
                ) : (
                    <span>待确认</span>
                );
                return <>{text}</>;
            },
            hidden: !invitationOne.cocreationFormEnabled,
        },

        {
            title: '开启状态',
            dataIndex: 'enabled',
            width: 80,
            render: (_, record) => <Switch checked={record?.invitationUsers?.enabled} checkedChildren="开启" unCheckedChildren="关闭" onChange={checked => changeStatus(checked, record)} />,
        },

        {
            title: () => (
                <>
                    <span>服务通知</span>
                    <Tooltip title="该功能设置发送后会给【订阅】了小程序服务通知的用户发送一条服务通知；但若当前嘉宾未订阅小程序服务通知，即使设置了发送，也收不到服务通知。">
                        <i className="bi bi-question-circle-fill popover-tip-icon"></i>
                    </Tooltip>
                </>
            ),
            dataIndex: 'notices',
            width: 100,
            render: (_, record) => {
                return (
                    <>
                        {record.invitationUsers.messageStatus === 2 && (
                            <Tooltip title={record.invitationUsers.messageResult}>
                                <Text type="danger" style={{ verticalAlign: 'middle' }}>
                                    发送失败
                                </Text>
                                <i className="bi bi-chat-dots" style={{ marginLeft: 4, color: '#888', verticalAlign: 'middle' }} />
                            </Tooltip>
                        )}
                        {record.invitationUsers.messageStatus === 1 && <Text type="success">发送成功</Text>}
                        {!record.invitationUsers.messageStatus && (
                            <Button size="small" type="primary" disabled={!record?.invitationUsers?.enabled} onClick={() => sendMessage(record)}>
                                发送
                            </Button>
                        )}
                    </>
                );
            },
        },

        {
            title: '操作',
            dataIndex: 'operations',
            width: 360,
            fixed: 'right',
            render: (_, record) => {
                const items = [{ label: 'PDF邀请函自定义设置', key: 'setupUserPdfInvitation', onClick: () => openSetupPdfInvitation(record) }, { label: 'Word邀请函自定义设置', key: 'setupUserInvitation', onClick: () => openSetupInvitation(record) }, { type: 'divider' }];

                // 会议进入劳务阶段，禁用代嘉宾确认任务
                if (conference && !conference?.laborFeeConfirmedAt) {
                    items.push({
                        label: '代嘉宾确认任务',
                        key: 'confirmInvite',
                        onClick: () => onConfirmInvitation(record),
                    });
                }

                items.push({ label: '确认受邀用户信息', key: 'confirm', onClick: () => openViewGuestInfoDrawer(record.id) });
                items.push({ type: 'divider' });
                items.push({ label: '删除邀请用户', key: 'delete', onClick: () => onDeleteInvitationUser(record.id), danger: true });

                // pdf定制邀请函 - 是否开启
                const invitationPdfSettings = record?.invitationUsers?.invitationPdfSettings;
                let isSwitchEnabled = true;
                if (invitationPdfSettings) {
                    isSwitchEnabled = JSON.parse(invitationPdfSettings)?.enabled !== false;
                }

                return (
                    <Space className="operation-btns" separator={<Divider orientation="vertical" />}>
                        {invitationOne?.type === 3 ? (
                            <>
                                <Popover
                                    placement="left"
                                    title="邀请函二维码"
                                    trigger="click"
                                    content={
                                        <>
                                            <QRCode id={record?.invitationUsers?.userCode} size={180} value={getInvitationUrl(record)} fgColor="#000" bgColor="#fff" includeMargin={true} />
                                            <div style={{ paddingLeft: 16, paddingBottom: 10 }}>
                                                <a download={`${record.memUsername}_${record?.invitationUsers?.userCode}`} id={`link_${record?.invitationUsers?.userCode}`} onClick={() => downloadQRCode(record)}>
                                                    下载二维码
                                                </a>
                                            </div>
                                        </>
                                    }
                                >
                                    <Button size="small" type="link" onClick={() => dispatch(setCursor(record.id))}>
                                        邀请函二维码
                                    </Button>
                                </Popover>

                                <Button size="small" type="link" onClick={() => copyInvitationLink(record)}>
                                    复制邀请链接
                                </Button>

                                {!!invitationOne.smsInfo
                                    && (() => {
                                        // 检查是否所有任务都为拒绝状态
                                        const allTasksRejected = record.agendasGuestsList && record.agendasGuestsList.length > 0 && record.agendasGuestsList.every(task => task.invitationAccepted === 2);

                                        // 所有任务都拒绝时，不展示邀请话术按钮
                                        if (allTasksRejected) {
                                            return null;
                                        }

                                        return (
                                            <Button size="small" type="link" onClick={() => copyInvitationText(record)}>
                                                复制邀请话术
                                            </Button>
                                        );
                                    })()}

                                {isSwitchEnabled && (
                                    <Button size="small" type="link" onClick={() => downloadInvitationPdfFile(record)} disabled={downloadPdfCountDown > 0}>
                                        下载PDF邀请函{downloadPdfCountDown > 0 ? `(${downloadPdfCountDown})` : ''}
                                    </Button>
                                )}

                                <Button size="small" type="link" onClick={() => downloadInvitationFile(record)} disabled={downloadCountDown > 0}>
                                    下载Word邀请函{downloadCountDown > 0 ? `(${downloadCountDown})` : ''}
                                </Button>
                            </>
                        ) : null}

                        <Dropdown menu={{ items }} placement="bottomRight">
                            <Button size="small" type="link" className="more-operation">
                                <i className="bi bi-three-dots" />
                            </Button>
                        </Dropdown>
                    </Space>
                );
            },
        },
    ].filter(c => !c.hidden); // 有隐藏列

    // 更改状态
    const changeStatus = async (checked, item) => {
        let accepted = false;
        if (item.agendasGuestsList?.length) {
            accepted = item.agendasGuestsList.some(agenda => agenda.invitationAccepted);
        }

        if (!checked && accepted) {
            Modal.confirm({
                title: '提示',
                icon: <i className="bi bi-exclamation-circle" />,
                content: `关闭邀请后，用户我的项目中将不再展示该邀请函，确认关闭邀请？`,
                okText: '确认',
                centered: true,
                cancelText: '取消',
                onOk: async () => {
                    const res = await invitationUsersStatusApi({ enabled: checked ? 1 : 0, invitationUserId: item.invitationUsers.id });
                    if (res.status_code === 200) {
                        getInvitationUsers();
                    }
                },
            });
        } else {
            const res = await invitationUsersStatusApi({ enabled: checked ? 1 : 0, invitationUserId: item.invitationUsers.id });
            if (res.status_code === 200) {
                getInvitationUsers();
            }
        }
    };

    // 导出邀请函链接
    const downloadFileToExcel = () => {
        if (!data) return message.warning('您未添加邀请用户，无法导出');
        exportInvitationLink(
            {
                groupId: invitationOne.groupId,
                invitationId: invitationOne.id,
            },
            { responseType: 'blob' },
        ).then(res => {
            const content = res;
            const blob = new Blob([content], { type: 'application/octet-stream' });
            const date = new Date();
            const showTime = dayjs(date).format('YYYYMMDDTHHmmss').toString();
            if ('download' in document.createElement('a')) {
                const link = document.createElement('a');
                // 文件名字
                link.download = `${invitationOne.id}_${invitationOne.name}_${showTime}.xlsx`;

                link.href = URL.createObjectURL(blob);
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
            } else {
                navigator.msSaveBlob(blob);
            }
        });
    };

    useEffect(() => {
        document.title = '邀请用户管理-医邀请';
    }, []);

    return (
        <>
            <div className="page-container invitation-users-page">
                <PageHeader
                    title={
                        <>
                            <i className="bi bi-chevron-left page-header-back-btn" onClick={() => navigate(`/invitation/g/${gid}/invitations`)} />
                            <span>邀请用户管理</span>
                        </>
                    }
                    breadcrumb={[{ label: '邀请组管理', path: '/invitation/groups' }, { label: invitationGroupOne, path: `/invitation/g/${gid}/invitations` }, { label: '邀请用户管理' }]}
                    {...filterToggleProps}
                />

                <FilterPanelSlot>
                    <InvitationUsersFilterPanel filter={filter} onFinish={onFinish} onReset={onReset} />
                </FilterPanelSlot>

                <div ref={tableRegionRef} className="invitation-users-table-region">
                    <div className="main-toolbar invitation-users-table-toolbar invitation-users-toolbar">
                        <div className="main-tools">
                            <Space>
                                <Button type="primary" onClick={openAddUserDrawer}>
                                    添加邀请用户
                                </Button>
                                {invitationOne?.invitationGroup?.applicationType === 1 && (
                                    <Space.Compact>
                                        <Button
                                            onClick={() => {
                                                navigate(`/conf/conferences/${invitationOne?.invitationGroup?.applicationItemId}/agendas`);
                                            }}
                                        >
                                            管理会议日程
                                        </Button>
                                        <Dropdown
                                            menu={{
                                                items: [
                                                    {
                                                        label: '管理会议嘉宾',
                                                        key: 'conf-guests',
                                                        onClick: () => {
                                                            navigate(`/conf/conferences/${invitationOne?.invitationGroup?.applicationItemId}/guests`);
                                                        },
                                                    },
                                                ],
                                            }}
                                            trigger={['click']}
                                        >
                                            <Button icon={<i className="bi bi-chevron-down" />} />
                                        </Dropdown>
                                    </Space.Compact>
                                )}
                            </Space>
                        </div>
                        <div className="sub-tools">
                            <Space>
                                <Button onClick={() => openSetupPdfInvitation()}>
                                    <i className="bi bi-gear" />
                                    PDF邀请函模板设置
                                </Button>
                                <Button onClick={() => openSetupInvitation()}>
                                    <i className="bi bi-gear" />
                                    Word邀请函模板设置
                                </Button>
                                {invitationOne.type === 3 && <Button onClick={downloadFileToExcel}>导出邀请话术</Button>}
                                <Tooltip title="刷新">
                                    <Button type="default" icon={<i className="bi bi-arrow-clockwise" />} onClick={handleRefresh} aria-label="刷新列表" />
                                </Tooltip>
                                <Tooltip title={isFullscreen ? '退出全屏' : '全屏'}>
                                    <Button type="default" onClick={handleToggleFullscreen} icon={<span className={isFullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-fullscreen'} aria-hidden="true" />} aria-label={isFullscreen ? '退出全屏' : '全屏'} />
                                </Tooltip>
                            </Space>
                        </div>
                    </div>

                    <div className="invitation-users-table-wrap">
                        <Table
                            className={tableScrollY != null ? 'custom-table-scrollbar-always' : undefined}
                            rowKey={item => item.id}
                            columns={columns}
                            dataSource={data}
                            rowClassName={row => (row.id === cursor ? 'store-cursor' : '')}
                            sticky
                            size="medium"
                            pagination={{
                                total,
                                showTotal: () => `共${total}条`,
                                current: filter.page,
                                pageSize: filter.pageSize,
                                pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
                                showQuickJumper: true,
                                showSizeChanger: { placement: 'topRight' },
                                onChange: onChangePage,
                                onShowSizeChange,
                            }}
                            scroll={{
                                x: 'max-content',
                                ...(tableScrollY != null ? { y: tableScrollY } : {}),
                            }}
                        />
                    </div>
                </div>
            </div>

            <Drawer
                closable={{ placement: 'end' }}
                title={!isEmpty(setupInvitationUser) ? 'Word邀请函自定义设置' : 'Word邀请函模板设置'}
                size={drawerWidth}
                layout="horizontal"
                open={visibleSetupInvitation}
                onClose={closeSetupInvitation}
                footer={
                    <div className="custom-drawer-footer" style={{ textAlign: 'right' }}>
                        <Space>
                            <Button onClick={closeSetupInvitation}>取消</Button>
                            <Button type="primary" onClick={setupInvitation}>
                                确定
                            </Button>
                        </Space>
                    </div>
                }
            >
                <Form name="setupInvitation" layout="vertical" form={setupInvitationForm} autoComplete="off">
                    {isEmpty(setupInvitationUser) && (
                        <Alert
                            type="warning"
                            title={
                                <>
                                    Word版邀请函模板设置，为邀请函中所有邀请用户设置统一的生成模板。
                                    <br />
                                    如需为某个邀请用户定制生成模板，请使用“<strong>操作-定制Word版邀请函</strong>”功能。
                                </>
                            }
                            style={{ marginBottom: 16 }}
                        />
                    )}

                    {!isEmpty(setupInvitationUser) && (
                        <Form.Item label="邀请用户">
                            {setupInvitationUser?.memUsername}
                            {`（${setupInvitationUser?.memMobile}）`}
                        </Form.Item>
                    )}

                    <Form.Item name="titleEnabled" label="自定义会议标题" valuePropName="checked" extra="开启自定义会议标题时，电子邀请函中会议标题按自定义标题和副标题展示；关闭则展示会议项目名称">
                        <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            return (
                                !!getFieldValue('titleEnabled') && (
                                    <div className="sub-form-fields">
                                        <Form.Item name="title" label="会议标题" rules={[{ required: true, message: '请填写会议标题' }]}>
                                            <Input placeholder="请输入会议标题" allowClear showCount maxLength={30} />
                                        </Form.Item>

                                        <Form.Item name="subtitle" label="副标题" style={{ marginBottom: 0 }}>
                                            <Input placeholder="请输入会议副标题" allowClear showCount maxLength={30} />
                                        </Form.Item>
                                    </div>
                                )
                            );
                        }}
                    </Form.Item>

                    <Form.Item name="coverUrl" label="封面图" extra="图片宽210mm高297mm，300PPI，支持JPG/PNG格式，大小不超过2MB">
                        {!!invitationFileCoverUrlList.length && (
                            <div className="invitation-user-image-wrap">
                                <AntdImage width={200} src={invitationFileCoverUrlList[0]} style={{ marginBottom: 8 }} />
                                <i
                                    className="bi bi-x-circle image-close-icon"
                                    onClick={() => {
                                        setInvitationFileCoverUrlList([]);
                                        setupInvitationForm.setFieldValue('coverUrl', '');
                                    }}
                                />
                            </div>
                        )}

                        <div>
                            <Upload beforeUpload={file => checkout(file, 2)} fileList={invitationFileCoverUrlList} customRequest={file => uploadInvitationCover(file, 1)} maxCount={1} showUploadList={false}>
                                <Button icon={<i className="bi bi-upload" />}>{!invitationFileCoverUrlList.length ? '上传图片' : '更改图片'}</Button>
                            </Upload>
                        </div>
                    </Form.Item>

                    <Form.Item name="bodyBgUrl" label="正文背景图" extra="图片宽210mm高297mm，页眉元素不高于25mm，300PPI，支持JPG/PNG格式，大小不超过2MB">
                        {!!invitationBodyBgUrlList.length && (
                            <div className="invitation-user-image-wrap">
                                <AntdImage width={200} src={invitationBodyBgUrlList[0]} style={{ marginBottom: 8 }} />
                                <i
                                    className="bi bi-x-circle image-close-icon"
                                    onClick={() => {
                                        setInvitationBodyBgUrlList([]);
                                        setupInvitationForm.setFieldValue('bodyBgUrl', '');
                                    }}
                                />
                            </div>
                        )}

                        <div>
                            <Upload beforeUpload={file => checkout(file, 2)} fileList={invitationBodyBgUrlList} customRequest={file => uploadInvitationBodyBg(file, 1)} maxCount={1} showUploadList={false}>
                                <Button icon={<i className="bi bi-upload" />}>{!invitationBodyBgUrlList.length ? '上传图片' : '更改图片'}</Button>
                            </Upload>
                        </div>
                    </Form.Item>

                    <Form.Item name="letterEnabled" label="邀请辞" valuePropName="checked" extra="开启邀请辞则根据邀请函设置展示邀请辞（邀请函未设置邀请辞时该选项不可用），关闭则不展示邀请辞">
                        <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            return (
                                !!getFieldValue('letterEnabled') && (
                                    <div className="sub-form-fields">
                                        <Form.Item name="redHeadEnabled" label="启用红头" valuePropName="checked" extra="开启后可在 Word 邀请函邀请辞页展示红头">
                                            <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                                        </Form.Item>

                                        {!!getFieldValue('redHeadEnabled') && (
                                            <Form.Item name="redHeadTitle" label="红头标题" rules={[{ required: true, message: '请选择红头标题' }]}>
                                                <Select
                                                    placeholder="请选择红头主体名称"
                                                    allowClear
                                                    options={WORD_INVITATION_RED_HEAD_TITLES.map(title => ({
                                                        label: title,
                                                        value: title,
                                                    }))}
                                                />
                                            </Form.Item>
                                        )}
                                    </div>
                                )
                            );
                        }}
                    </Form.Item>

                    <Form.Item name="confDetailsEnabled" label="大会详情" valuePropName="checked" extra="展示会议时间、地点、规模、组织架构、温馨提示等信息">
                        <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            return (
                                !!getFieldValue('confDetailsEnabled') && (
                                    <div className="sub-form-fields">
                                        <Form.Item name="confDetailsTitle" label="大会详情标题" rules={[{ required: true, message: '请填写大会详情标题' }]}>
                                            <Input placeholder="请输入大会详情标题" allowClear showCount maxLength={30} />
                                        </Form.Item>

                                        <Form.Item name="confDetails" label="大会详情内容" rules={[{ required: true, message: '请填写大会详情内容' }]}>
                                            <TinyMCEEditor
                                                form={setupInvitationForm}
                                                id="confDetails"
                                                fieldValue="confDetails"
                                                initialValue={isEmpty(setupInvitationUser) ? invitationOne?.invitationFileSettings?.confDetails : setupInvitationUser?.invitationUsers?.invitationFileSettings?.confDetails}
                                                placeholder="请输入大会详情内容"
                                            />
                                        </Form.Item>
                                    </div>
                                )
                            );
                        }}
                    </Form.Item>

                    <Form.Item name="taskEnabled" label="嘉宾任务" valuePropName="checked" extra="开启嘉宾任务，可展示嘉宾日程表格或电子邀请函二维码" style={{ marginBottom: 10 }}>
                        <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                    </Form.Item>

                    <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                            return (
                                !!getFieldValue('taskEnabled') && (
                                    <div className="sub-form-fields">
                                        <Form.Item name="taskForm" label="嘉宾任务形式" rules={[{ required: true, message: '请选择嘉宾任务形式' }]}>
                                            <Radio.Group>
                                                <Radio value={1}>嘉宾日程任务表格</Radio>
                                                <Radio value={2}>电子邀请函二维码</Radio>
                                                <Radio value={3}>嘉宾日程任务表格+电子邀请函二维码</Radio>
                                            </Radio.Group>
                                        </Form.Item>

                                        <Form.Item name="contactFrom" label="联系人来源" rules={[{ required: true, message: '请选择嘉宾联系人来源' }]} style={{ marginBottom: 8 }}>
                                            <Radio.Group>
                                                <Radio value={1}>来自邀请函设置</Radio>
                                                <Radio value={2}>自定义联系人</Radio>
                                            </Radio.Group>
                                        </Form.Item>

                                        {getFieldValue('contactFrom') === 2 && (
                                            <div className="customized-contacts">
                                                <Form.List name="contacts">
                                                    {(fields, { add, remove, move }) => {
                                                        if (fields.length > 0) {
                                                            setupWordContactsEnsureRef.current = false;
                                                        } else if (!setupWordContactsEnsureRef.current) {
                                                            setupWordContactsEnsureRef.current = true;
                                                            queueMicrotask(() => {
                                                                add();
                                                                setupWordContactsEnsureRef.current = false;
                                                            });
                                                        }

                                                        return (
                                                            <div className="contacts">
                                                                {fields.length < 5 && (
                                                                    <Button
                                                                        type="link"
                                                                        size="small"
                                                                        style={{ marginBottom: 10 }}
                                                                        icon={
                                                                            <span className="anticon">
                                                                                <i className="bi bi-plus-circle" />
                                                                            </span>
                                                                        }
                                                                        onClick={() => add()}
                                                                    >
                                                                        <span style={{ marginLeft: 4 }}>新增联系人</span>
                                                                    </Button>
                                                                )}

                                                                {fields.map(({ key, name, ...restField }, idx) => (
                                                                    <div className="customized-contact" key={key} style={{ marginBottom: 16 }}>
                                                                        <Row gutter={10}>
                                                                            <Col span={8}>
                                                                                <Form.Item name={[name, 'name']} style={{ marginBottom: 0 }} rules={[{ required: true, message: '' }]}>
                                                                                    <Input placeholder="联系人" />
                                                                                </Form.Item>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Form.Item name={[name, 'phone']} style={{ marginBottom: 0 }} rules={[{ required: true, message: '' }]}>
                                                                                    <Input placeholder="联系电话" />
                                                                                </Form.Item>
                                                                            </Col>
                                                                            <Col span={8} style={{ display: 'flex', alignItems: 'center' }}>
                                                                                {fields.length > 1 && (
                                                                                    <Button
                                                                                        type="link"
                                                                                        size="small"
                                                                                        className="link-btn-operations"
                                                                                        icon={
                                                                                            <span className="anticon">
                                                                                                <i className="bi bi-x-circle" />
                                                                                            </span>
                                                                                        }
                                                                                        onClick={() => remove(name)}
                                                                                    >
                                                                                        移除
                                                                                    </Button>
                                                                                )}

                                                                                {idx !== 0 && (
                                                                                    <Button
                                                                                        type="link"
                                                                                        size="small"
                                                                                        className="link-btn-operations"
                                                                                        icon={
                                                                                            <span className="anticon">
                                                                                                <i className="bi bi-arrow-up-circle" />
                                                                                            </span>
                                                                                        }
                                                                                        onClick={() => move(idx, idx - 1)}
                                                                                    >
                                                                                        上移
                                                                                    </Button>
                                                                                )}

                                                                                {idx !== fields.length - 1 && (
                                                                                    <Button
                                                                                        type="link"
                                                                                        size="small"
                                                                                        className="link-btn-operations"
                                                                                        icon={
                                                                                            <span className="anticon">
                                                                                                <i className="bi bi-arrow-down-circle" />
                                                                                            </span>
                                                                                        }
                                                                                        onClick={() => move(idx, idx + 1)}
                                                                                    >
                                                                                        下移
                                                                                    </Button>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        );
                                                    }}
                                                </Form.List>
                                            </div>
                                        )}
                                    </div>
                                )
                            );
                        }}
                    </Form.Item>

                    <Form.Item label="日程详情" extra="开启则仅展示与嘉宾相关的分论坛日程，关闭则展示所有分论坛日程（过滤无日程的分论坛）">
                        <span style={{ marginRight: 8 }}>仅导出嘉宾出席的分论坛日程</span>
                        <Form.Item name="relatedConfHallsOnly" valuePropName="checked" noStyle>
                            <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                        </Form.Item>
                    </Form.Item>
                </Form>
            </Drawer>

            <Drawer
                closable={{ placement: 'end' }}
                title={!isEmpty(setupInvitationUser) ? 'PDF官方邀请函' : 'PDF官方邀请函模板设置'}
                size={drawerWidth}
                layout="horizontal"
                open={visibleSetupPdfInvitation}
                onClose={closeSetupPdfInvitation}
                footer={
                    <div className="custom-drawer-footer" style={{ textAlign: 'right' }}>
                        <Space>
                            <Button onClick={closeSetupPdfInvitation}>取消</Button>
                            <Button type="primary" onClick={setupPdfInvitation}>
                                确定
                            </Button>
                        </Space>
                    </div>
                }
                className="pdf-invitation-drawer"
            >
                <Form name="setupPdfInvitationForm" layout="vertical" form={setupPdfInvitationForm} autoComplete="off">
                    {isEmpty(setupInvitationUser) && (
                        <Alert
                            type="warning"
                            title={
                                <>
                                    <div>PDF官方邀请函模板设置，为邀请函中所有邀请用户设置统一的生成模板。</div>
                                    <div>如需为某个邀请用户定制生成模板，请使用“操作-定制PDF官方邀请函”功能。</div>
                                </>
                            }
                            style={{ marginBottom: 16 }}
                        />
                    )}

                    {!isEmpty(setupInvitationUser) && (
                        <Form.Item
                            name="enabled"
                            label="PDF邀请函"
                            valuePropName="checked"
                            extra={
                                <>
                                    <div>开启：系统与人工均可为该专家生成PDF邀请函，该专家在线邀请函显示“查看/下载”按钮。</div>
                                    <div>关闭：系统不会为该专家生成PDF邀请函，该专家在线邀请函隐藏“查看/下载”按钮。</div>
                                </>
                            }
                        >
                            <Switch checkedChildren="开启" unCheckedChildren="关闭" />
                        </Form.Item>
                    )}

                    {(isEmpty(setupInvitationUser) || (!isEmpty(setupInvitationUser) && watchEnabled)) && (
                        <>
                            <Form.Item label="背景图" extra="图片宽210mm高297mm，页眉元素不高于25mm，300PPI，支持JPG/PNG格式，大小不超过2MB">
                                {!!pdfInvitationBodyBgUrlList.length && (
                                    <div className="invitation-user-image-wrap">
                                        <AntdImage width={200} src={pdfInvitationBodyBgUrlList[0]} style={{ marginBottom: 8 }} />
                                        <i
                                            className="bi bi-x-circle image-close-icon"
                                            onClick={() => {
                                                setPdfInvitationBodyBgUrlList([]);
                                                setupPdfInvitationForm.setFieldValue('bodyBgUrl', '');
                                            }}
                                        />
                                    </div>
                                )}

                                <Upload beforeUpload={file => checkout(file, 2)} fileList={pdfInvitationBodyBgUrlList} customRequest={file => uploadInvitationBodyBg(file, 2)} maxCount={1} showUploadList={false}>
                                    <Button icon={<i className="bi bi-upload" />}>{!pdfInvitationBodyBgUrlList.length ? '上传图片' : '更改图片'}</Button>
                                </Upload>
                            </Form.Item>
                            <Form.Item name="bodyBgUrl" hidden>
                                <Input />
                            </Form.Item>

                            <Form.Item name="letterFrom" label="邀请辞">
                                <Radio.Group>
                                    <Radio value={1}>来自邀请函设置</Radio>
                                    <Radio value={2}>自定义邀请辞</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item noStyle shouldUpdate>
                                {({ getFieldValue }) => {
                                    return (
                                        getFieldValue('letterFrom') === 2 && (
                                            <div className="sub-form-fields">
                                                <Form.Item name="letter" rules={[{ required: true, message: '请填写自定义邀请辞内容' }]}>
                                                    <TinyMCEEditor
                                                        form={setupPdfInvitationForm}
                                                        id="letter"
                                                        fieldValue="letter"
                                                        initialValue={isEmpty(setupInvitationUser) ? invitationOne?.invitationPdfSettings?.letter : setupInvitationUser?.invitationUsers?.invitationPdfSettings?.letter}
                                                        placeholder="请输入自定义邀请辞内容"
                                                    />
                                                </Form.Item>
                                            </div>
                                        )
                                    );
                                }}
                            </Form.Item>

                            <Form.Item name="contactFrom" label="专属联系人">
                                <Radio.Group>
                                    <Radio value={1}>来自邀请函设置</Radio>
                                    <Radio value={2}>自定义联系人</Radio>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item noStyle shouldUpdate>
                                {({ getFieldValue }) => {
                                    return (
                                        getFieldValue('contactFrom') === 2 && (
                                            <div className="customized-contacts">
                                                <Form.List name="contacts">
                                                    {(fields, { add, remove, move }) => {
                                                        if (fields.length > 0) {
                                                            setupPdfContactsEnsureRef.current = false;
                                                        } else if (!setupPdfContactsEnsureRef.current) {
                                                            setupPdfContactsEnsureRef.current = true;
                                                            queueMicrotask(() => {
                                                                add();
                                                                setupPdfContactsEnsureRef.current = false;
                                                            });
                                                        }

                                                        return (
                                                            <div className="contacts">
                                                                {fields.length < 10 && (
                                                                    <Button
                                                                        type="link"
                                                                        size="small"
                                                                        style={{ marginBottom: 10 }}
                                                                        icon={
                                                                            <span className="anticon">
                                                                                <i className="bi bi-plus-circle" />
                                                                            </span>
                                                                        }
                                                                        onClick={() => add()}
                                                                    >
                                                                        <span style={{ marginLeft: 4 }}>新增联系人</span>
                                                                    </Button>
                                                                )}

                                                                {fields.map(({ key, name, ...restField }, idx) => (
                                                                    <div className="customized-contact" key={key} style={{ marginBottom: 16 }}>
                                                                        <Row gutter={10}>
                                                                            <Col span={8}>
                                                                                <Form.Item name={[name, 'userName']} style={{ marginBottom: 0 }} rules={[{ required: true, message: '' }]}>
                                                                                    <Input placeholder="联系人" />
                                                                                </Form.Item>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Form.Item name={[name, 'phone']} style={{ marginBottom: 0 }} rules={[{ required: true, message: '' }]}>
                                                                                    <Input placeholder="联系电话" />
                                                                                </Form.Item>
                                                                            </Col>
                                                                            <Col span={8} style={{ display: 'flex', alignItems: 'center' }}>
                                                                                {fields.length > 1 && (
                                                                                    <Button
                                                                                        type="link"
                                                                                        size="small"
                                                                                        className="link-btn-operations"
                                                                                        icon={
                                                                                            <span className="anticon">
                                                                                                <i className="bi bi-x-circle" />
                                                                                            </span>
                                                                                        }
                                                                                        onClick={() => remove(name)}
                                                                                    >
                                                                                        移除
                                                                                    </Button>
                                                                                )}

                                                                                {idx !== 0 && (
                                                                                    <Button
                                                                                        type="link"
                                                                                        size="small"
                                                                                        className="link-btn-operations"
                                                                                        icon={
                                                                                            <span className="anticon">
                                                                                                <i className="bi bi-arrow-up-circle" />
                                                                                            </span>
                                                                                        }
                                                                                        onClick={() => move(idx, idx - 1)}
                                                                                    >
                                                                                        上移
                                                                                    </Button>
                                                                                )}

                                                                                {idx !== fields.length - 1 && (
                                                                                    <Button
                                                                                        type="link"
                                                                                        size="small"
                                                                                        className="link-btn-operations"
                                                                                        icon={
                                                                                            <span className="anticon">
                                                                                                <i className="bi bi-arrow-down-circle" />
                                                                                            </span>
                                                                                        }
                                                                                        onClick={() => move(idx, idx + 1)}
                                                                                    >
                                                                                        下移
                                                                                    </Button>
                                                                                )}
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        );
                                                    }}
                                                </Form.List>
                                            </div>
                                        )
                                    );
                                }}
                            </Form.Item>
                        </>
                    )}
                </Form>
            </Drawer>

            {/* PDF下载Modal */}
            <Modal title="下载PDF官方邀请函" open={pdfDownloadModalOpen} onCancel={() => setPdfDownloadModalOpen(false)} centered footer={null} width={500}>
                {currentPdfRecord && (
                    <div style={{ padding: '20px 0' }}>
                        <div style={{ marginBottom: 16 }}>
                            <strong>嘉宾：</strong>
                            {currentPdfRecord.memUsername}
                        </div>

                        {currentPdfRecord?.invitationUsers?.pdfUrl ? (
                            <>
                                <div style={{ marginBottom: 16, color: '#52c41a' }}>已生成PDF邀请函</div>
                                <div style={{ marginBottom: 16 }}>
                                    <strong>生成时间：</strong>
                                    {dayjs(currentPdfRecord.invitationUsers.pdfCreatedAt).format('YYYY-MM-DD HH:mm:ss')}
                                </div>
                                <Alert type="warning" title="系统每天 06:00, 12:00, 15:00, 21:00 自动批量重新生成，也可直接点击“重新生成”按钮立即重新生成。" style={{ marginBottom: 16 }} />
                                <div style={{ display: 'flex', gap: 8 }}>
                                    <Button type="primary" onClick={() => downloadExistingPdf(currentPdfRecord)}>
                                        立即下载
                                    </Button>
                                    <Button onClick={() => regeneratePdfInvitation(currentPdfRecord)} disabled={downloadPdfCountDown > 0}>
                                        重新生成{downloadPdfCountDown > 0 ? `(${downloadPdfCountDown})` : ''}
                                    </Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div style={{ marginBottom: 16, color: '#faad14' }}>尚未生成PDF邀请函</div>
                                <Alert type="warning" title="系统每天 06:00, 12:00, 15:00, 21:00 自动批量生成，也可直接点击“生成邀请函”按钮立即生成。" style={{ marginBottom: 16 }} />
                                <Button type="primary" onClick={() => regeneratePdfInvitation(currentPdfRecord)} disabled={downloadPdfCountDown > 0}>
                                    生成邀请函{downloadPdfCountDown > 0 ? `(${downloadPdfCountDown})` : ''}
                                </Button>
                            </>
                        )}
                    </div>
                )}
            </Modal>

            <GuestRemarksEditModal open={remarksModalOpen} form={remarksForm} saving={remarksSaving} onCancel={closeRemarksEditor} onOk={handleSaveRemarks} />

            {/* 邀请话术 Modal */}
            <InvitationScriptModal
                open={invitationScriptModalVisible}
                onCancel={() => {
                    setInvitationScriptModalVisible(false);
                    setCurrentGuestForScript(null);
                }}
                guestData={currentGuestForScript}
                invitationOne={invitationOne}
            />

            <ConfirmInvite open={confirmInviteOpen} setConfirmInviteOpen={setConfirmInviteOpen} userCode={currentUserCode} updateList={getInvitationUsers} />

            <AddGuest closeAddUserDrawer={closeAddUserDrawer} visibleAddUserDrawer={visibleAddUserDrawer} setVisibleAddUserDrawer={setVisibleAddUserDrawer} onResetGuest={onResetGuest} />

            <GuestInfo guestInfoDrawer={guestInfoDrawer} closeGuestInfoDrawer={closeGuestInfoDrawer} expertId={currentExpertId} invitationId={id} />
        </>
    );
}
